import { render } from "./Step3.vue?vue&type=template&id=2248101e"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleForm/ScalingUp/Step3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2248101e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2248101e', __exports__)) {
    api.reload('2248101e', __exports__)
  }
  
  module.hot.accept("./Step3.vue?vue&type=template&id=2248101e", () => {
    api.rerender('2248101e', render)
  })

}


export default __exports__